import type { ReactNode } from "react";
import { Logo } from "@/components/logo";

type Props = {
  children: ReactNode;
};

/**
 * Shared layout for the unauthenticated pages: login, signup, OTP,
 * create-password, forgot-password, reset-password. Provides the grey-25 canvas,
 * the sanctions.io logo above the centered card slot, and the faint half-globe
 * wireframe (public/brand/auth-globe.svg) anchored to the bottom of the viewport
 * with its lower portion clipped to match Figma.
 *
 * Figma frames: 15079:13618 (Login), 15090:6628 (OTP), 15090:7090 (Signup),
 * 15146:7083 (Create password). Welcomedashboard uses a different layout
 * (no logo, no globe, wider soft-shadowed card) and stays in its page file.
 */
export function AuthLayout({ children }: Props) {
  return (
    <div className="relative min-h-screen overflow-hidden bg-grey-25">
      <img
        src="/brand/auth-globe.svg"
        alt=""
        aria-hidden
        draggable={false}
        className="pointer-events-none absolute bottom-0 left-1/2 -mb-[14vw] w-[86vw] max-w-[1234px] -translate-x-1/2 select-none"
      />
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center gap-12 px-8 py-12">
        <Logo className="h-8 w-auto" />
        {children}
      </div>
    </div>
  );
}
